import { setupWorker } from 'msw'
import { handlers } from './handlers'

export const worker = setupWorker(...handlers)

const ALLOWED_HOSTS = ['localhost', '127.0.0.1']

// safeStart() wraps worker.start() with a runtime hostname guard.
// Throws if called outside localhost — defends against an accidental
// REACT_APP_MSW=true production build silently mocking patient API calls.
export function safeStart(): ReturnType<typeof worker.start> {
  if (!ALLOWED_HOSTS.includes(window.location.hostname)) {
    throw new Error(
      `[MSW] Refusing to start outside localhost (hostname: ${window.location.hostname}). ` +
      `Ensure REACT_APP_MSW=true is not set in production builds.`
    )
  }
  return worker.start({ onUnhandledRequest: 'warn' })
}
